import { useContext, useEffect } from 'react';
import { CampaignMemberStatusContext } from './CampaignMemberStatusContext';
import { useCampaignMemberStatuses } from './useCampaignMemberStatuses';
import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../../../reducers/userInfoReducer';

export const useEffectFetchCampaignMemberStatuses = (campaignId: string) => {
  const { loadCampaignMemberStatuses, loadStatus } = useCampaignMemberStatuses();
  const defaultConfigurationId = useSelector(selectDefaultCreationCrmOrgId);

  const ctx = useContext(CampaignMemberStatusContext);

  useEffect(() => {
    if (loadStatus === 'idle' && defaultConfigurationId) {
      loadCampaignMemberStatuses(campaignId);
    }
  }, [campaignId, loadCampaignMemberStatuses, loadStatus, defaultConfigurationId]);

  return ctx;
};
